<template>
    <transition name="fade">
        <div id="editor_trace" v-if="showEditor" @click.self="maskClickEvn">
            <div class="editor_trace">
                <div class="editor_trace1">
                    <div class="flex">
                        <span class="t-m-r-20">AI痕迹</span>
                        <textLoading v-if="streamStatus"></textLoading>
                    </div>
                    <img class="cursor_1" src="../assets/image/icon_close.png" alt="" @click="closePopup">
                </div>
                <div class="editor_trace2">
                    <div class="editor_trace3">
                        <div class="editor_trace3_1">
                            需要去AI痕迹的内容
                        </div>
                        <div class="editor_trace3_2">
                            <!-- <el-input type="textarea" :autosize="{ minRows: 8 }" :placeholder="placeholder"
                                v-model="traceText">
                            </el-input> -->
                            <editBox v-model="traceText" :placeholder="placeholder"></editBox>
                        </div>
                        <div class="editor_trace3_3">
                            <div class="editor_trace3_4 cursor_1" @click="aiTrace">AI生成</div>
                        </div>
                    </div>
                    <div class="editor_trace4" v-if="traceShow">
                        <div class="editor_trace4_1" ref="editortrace4">
                            <el-input v-if="!streamStatus" type="textarea" :autosize="{ minRows: 8, }"
                                :placeholder="placeholder" v-model="traceCotent">
                            </el-input>
                            <!-- <editBox v-if="!streamStatus" v-model="markedTraceCotent"></editBox> -->
                            <div v-else v-html="markedTraceCotent"></div>
                        </div>
                         <!-- 停止生成按钮 -->
                        <AIStopCreate :hide="streamStatus" emit @stop="clearTimers" bottom="80px"></AIStopCreate>
                        <div class="editor_trace4_2">
                            <div class="editor_trace3_4 cursor_1" @click="replace">替换原文</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
import { EventBus } from '@/utils/eventBus'
import editBox from '@/components/edit_box.vue' // 文本编辑框
import textLoading from '@/components/text_loading.vue';
import api from '@/api/api';
import { marked } from 'marked';
export default {
    components: {
        editBox, textLoading
    },
    props: {
        maskClick: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            showEditor: false, //显示隐藏
            traceShow: false, //显示右侧
            traceText: '', //去痕内容
            traceCotent: '',//去痕结果
            markedTraceCotent: '',//去痕结果
            placeholder: '请粘贴需要去AI痕迹的内容，必须是从正文内容中复制的完整段落内容',
            streamStatus: false, // 流式请求 false请求结束 true请求
            streamIndex: 0, // 流式请求下标
            debounceTimer: null, // 防抖定时器
            typingTimer: null, // 打字效果定时器
            streamLast: false, //流式最后一条
            isStop: false,
        }
    },
    beforeDestroy() {
        this.clearTimers()
    },
    methods: {
         //销毁定时器
        clearTimers(status) {
            console.log('销毁定时器');
            this.streamIndex = 0
            this.streamStatus = false
            this.streamLast = false
            clearTimeout(this.debounceTimer)
            clearInterval(this.typingTimer)
        },
        //Ai去痕迹
        aiTrace() {
            if (this.traceText.trim() === '') {
                this.$message.warning('请输入AI痕迹的内容！')
                return
            }
            let params = {
                content: this.stripHtmlTags(this.traceText)
            }
            this.AIWrite({
                length: '中',
                haveId: false,
                type: 'aiclear',
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.traceCotent = ''
                    this.markedTraceCotent = ''
                    this.streamStatus = true
                    this.traceShow = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite('aiclear', {
            //     content: this.stripHtmlTags(this.traceText)
            // }).then((res) => {
            //     if (res.code == 200) {
            //         this.traceCotent = ''
            //         this.markedTraceCotent = ''
            //         this.streamStatus = true
            //         this.traceShow = true
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer)
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data && res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length
                            let combinedText = ''
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item
                                }
                            })
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.clearTimers()
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    sessionStorage.removeItem('streamStatus');
                                    this.$message.success('AI生成完成！');
                                } else {
                                    this.getStreamContent(id);
                                }
                            })
                        } else {
                            this.getStreamContent(id)
                        }
                    } else {
                        this.clearTimers()
                        this.$message.warning(res.msg)
                    }
                })
            }, 500)
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0
            if (this.typingTimer) {
                clearInterval(this.typingTimer)
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    this.traceCotent += text[index]
                    this.markedTraceCotent = this.traceCotent.replace(/\n/g, '<br>')
                    index++
                    this.$nextTick(() => {
                        const container = this.$refs.editortrace4;
                        if (container) {
                            container.scrollTop = container.scrollHeight; // 直接滚动到底部
                        }
                    });
                } else {
                    clearInterval(this.typingTimer)
                    if (callback) {
                        callback()
                    }
                }
            }, 20)
        },
        // 打开
        open() {
            this.showEditor = true
            this.traceShow = false
            this.traceCotent = ''
            this.traceText = ''
        },
        //蒙层点击事件
        maskClickEvn() {
            if (this.maskClick) return
            this.closePopup();
        },
        // 关闭
        closePopup() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            this.showEditor = false
        },
        // 替换原文
        replace() {
            if (this.streamStatus) {
                this.$message.warning('请等待Ai生成完毕！')
                return
            }
            // console.log(this.traceText)
            EventBus.$emit('replace', {
                text: this.stripHtmlTags(this.traceText),
                content: this.markedTraceCotent
            })
            this.showEditor = false
        }
    }
}
</script>

<style lang="scss">
#editor_trace {
    width: 100vw;
    height: 100vh;
    background: rgba(14, 14, 14, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

.editor_trace {
    height: 70vmin !important;
    background: #FFFFFF;
    border-radius: 10px;
}

.editor_trace1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    font-size: 18px;
    color: #111111;
    height: 65px;
    padding: 0 30px;
    border-bottom: 1px solid #E6EBF0;
}

.editor_trace1 img {
    width: 21px;
    height: 21px;
    cursor: pointer;
}

.editor_trace2 {
    display: flex;
    height: calc(100% - 65px);
}

.editor_trace3 {
    width: 525px;
    display: flex;
    flex-direction: column;
}

.editor_trace3_1 {
    font-weight: bold;
    font-size: 16px;
    color: #111111;
    margin: 15px 0 15px 30px;
}

.editor_trace3_2 {
    flex: 1;
    width: calc(100% - 60px);
    height: 280px;
    margin: 0 30px;
    background-color: #FAFAFA;
    overflow: hidden;
    padding: 10px;
    border-radius: 5px;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.editor_trace4_1 .el-textarea__inner,
.editor_trace3_2 .el-textarea__inner {
    font-size: 15px;
    color: #111111;
    border: none;
    resize: none;
    padding: 0;
    background-color: #FAFAFA;
}

.editor_trace4_1 .el-textarea__inner {
    background-color: #FFFFFF;
    @include scrollbar($sw:none)
}

.editor_trace3_3 {
    width: 100%;
    height: 73px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

.editor_trace3_4 {
    width: 125px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: var(--tech-primary);
    border-radius: 8px;
    font-size: 15px;
    color: #FFFFFF;
    cursor: pointer;
}

.editor_trace4 {
    width: 525px;
    height: 100%;
    border-left: 1px solid #E6EBF0;
    position: relative;
}

.editor_trace4_1 {
    height: calc(100% - 84px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    padding: 15px 30px;
    position: relative;
}

.editor_trace4_2 {
    width: 100%;
    height: 73px;
    border-top: 1px solid #E6EBF0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>